<template>
  <div id="Zbcp">
    <div class="header">
      <el-form :inline="true" class="demo-form-inline forms">
        <el-form-item label="默认显示页面：">
          <el-input v-model.trim="queryForm.active" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="primary" @click="reset">重置</el-button>
          <el-button type="primary" @click="add">添加</el-button>
          <!-- <el-button type="primary" @click="download">打印</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <div class="content">
        <el-table :data="tableData" style="width: 100%" ref="table">
          <el-table-column prop="id" label="编号" key="id"></el-table-column>
          <el-table-column prop="title" label="标题" key="title">
          </el-table-column>
          <el-table-column prop="active" label="默认显示页面" key="active">
            <template slot-scope="scope">
              {{
                scope.row.active == 0 ? "否" : scope.row.active == 1 ? "是" : ""
              }}
            </template>
          </el-table-column>
          <el-table-column width="180" key="todo" label="操作">
            <template slot-scope="scope">
              <el-button
                @click="defaultShow(scope.$index, scope.row)"
                size="small"
                :disabled="scope.row.active === 1"
                >默认</el-button
              >
              <span @click="bj(scope.$index, scope.row)" class="btns"
                >编辑</span
              >
              <span @click="sc(scope.$index, scope.row)" class="btns"
                >删除</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog
      title="修改关于我们"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        ref="editForm"
        :rules="rules"
      >
        <el-form-item label="标题：" prop="title">
          <el-input v-model.trim="editForm.title"></el-input>
        </el-form-item>
        <el-form-item label="内容：" prop="content">
          <vue-editor
            id="editor"
            useCustomImageHandler
            @image-added="handleImageAdded"
            v-model="editForm.content"
          >
          </vue-editor>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancel('editForm')">取消</el-button>
        <el-button type="primary" @click.native="handleUpdate('editForm')"
          >更新</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="添加关于我们"
      :visible.sync="newData"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="newClose"
    >
      <el-form
        :model="newForm"
        label-width="120px"
        ref="newForm"
        :rules="rules"
      >
        <el-form-item label="标题：" prop="title">
          <el-input v-model.trim="newForm.title"></el-input>
        </el-form-item>
        <el-form-item label="内容：" prop="content">
          <vue-editor
            id="editor"
            useCustomImageHandler
            @image-added="handleImageAdded"
            v-model="newForm.content"
          >
          </vue-editor>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="newCancel('newForm')">取消</el-button>
        <el-button type="primary" @click.native="newUpdate('newForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getOur } from "./../axios/api";
import { VueEditor } from "vue2-editor";
import moment from "dayjs";
export default {
  name: "Our",
  components: {
    VueEditor,
  },
  data() {
    return {
      imagesWF: [],
      tableData: [],
      total: 0, //默认数据总数
      pagesize: 10, //每页的数据条数
      currentPage: 1, //默认开始页面
      newData: false,
      queryForm: {},
      newForm: {},
      editFormVisible: false,
      editForm: {},
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 上传图片时的钩子
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      var that = this;
      const formData = new FormData();
      if (file) {
        formData.append("file", file);
      }
      // console.log(formData.get("file"));
      // return;
      getOur
        .upload(formData)
        .then(function (res) {
          // console.log(res);
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            // console.log(res.data);
            //cursorLocation是光标位置，res.data.url是上传后的url地址
            Editor.insertEmbed(cursorLocation, "image", res.data.url);
            resetUploader(); //重置文件上传器
            that.$message.success("图片上传成功!");
            return res.data.url;
          }
        })
        .catch(function (res) {});
    },

    search: function () {
      this.currentPage = 1;
      this.init();
    },
    reset: function () {
      this.queryForm = {};
      this.currentPage = 1;
      this.init();
    },

    // 添加
    add: function () {
      this.newData = true;
    },

    newClose(done) {
      this.newData = false;
      this.newForm = {};
      this.$refs["newForm"].clearValidate();
    },
    newCancel: function () {
      this.newData = false;
      this.newForm = {};
      this.$refs["newForm"].clearValidate();
    },
    newUpdate() {
      var that = this;
      that.$refs["newForm"].validate((valid) => {
        if (valid) {
          let data = {
            title: that.newForm.title,
            content: that.newForm.content,
          };

          // console.log(data);
          // return;
          getOur
            .addTable(JSON.stringify(data))
            .then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                that.$message.success("添加成功!");
                that.newData = false;
                that.newForm = {};
                that.$refs["newForm"].resetFields();
                that.init();
              }
            })
            .catch(function (res) {
              that.$alert(res.message + "!", "提示", {
                confirmButtonText: "确定",
              });
            });
        }
      });
    },

    // 编辑
    bj: function (index, row) {
      var that = this;
      this.editFormVisible = true; //显示弹框

      this.editForm = row; // editForm是Dialog弹框的data
    },
    handleClose(done) {
      this.editFormVisible = false;
    },
    handleCancel: function () {
      this.editFormVisible = false;
    },
    handleUpdate: function () {
      var that = this;
      let data = {
        title: that.editForm.title,
        content: that.editForm.content,
      };

      // console.log(data);
      // return;
      getOur
        .editTable(data, that.editForm.id)
        .then(function (res) {
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            that.$message.success("更新成功!");
            that.editFormVisible = false;
            that.$refs["editForm"].resetFields();
            that.init();
          }
        })
        .catch(function (res) {
          that.editFormVisible = false;
          that.$refs["editForm"].resetFields();
          // console.log(res)
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    // 设置默认显示
    defaultShow: function (index, row) {
      var that = this;
      let data = {
        id: row.id,
      };
      this.$confirm("确定要设置为默认显示页面?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          getOur
            .morenTodo(JSON.stringify(data))
            .then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                // that.currentPage = 1;
                that.init();
                that.$message({
                  type: "success",
                  message: "设置成功!",
                });
              }
            })
            .catch(function (error) {
              that.$message({
                type: "info",
                message: res.message,
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 删除
    sc: function (index, row) {
      var that = this;
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          getOur
            .delTable({
              id: row.id,
            })
            .then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                // that.currentPage = 1;
                that.init();
                that.$message({
                  type: "success",
                  message: "删除成功!",
                });
              }
            })
            .catch(function (error) {
              that.$message({
                type: "info",
                message: res.message,
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    init: function () {
      var that = this;
      var data = {
        active: that.queryForm.active ? that.queryForm.active : undefined,
        pageSize: that.pagesize,
        pageNumber: that.currentPage,
      };
      //获取table列表
      getOur.getTable(data).then(function (res) {
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定",
          });
        } else {
          const { list, totalNumber } = res.data;
          list.map((lis) => {
            lis.createdAt = moment(new Date(lis.createdAt * 1000)).format(
              "YYYY-MM-DD"
            );
          });

          that.total = totalNumber;
          that.tableData = list;
        }
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/page/Our.vue